// extracted by mini-css-extract-plugin
export default {"searchInput":"GGRoDB2iw8en2gz_R1HY"};